<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('packaging-info-text')"
          :title="$t('packaging')"
          :btnText="$t('Add packaging')"
          @action="openNewPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            @click="openEditPopup(item.id)"
            class="list-table-item"
            v-for="(item, index) in get_packages.items" :key="`item-${index}`">
            <div class="table-cell small" :key="`icon-${packagingItemName(item.type)}`">
              <Icon
                :circle=true
                :name="packagingItemName(item.type)"
                size="20"/>
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.name}` }}
              </span>
                <span class="additional-info">{{ `${item.length}` }} x {{ `${item.width}` }} x {{ `${item.height}` }} {{item.dimension_measure}} - {{ item.weight}} {{item.weight_measure}}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupMedium=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showConfirmButton="!deletePackaging"
      :showDeleteButton="deletePackaging"
      @cancel="togglePopup"
      @deleteAction="deletePackageAction"
      @confirm="submitForm">
      <template v-slot:header>
        <h2 v-if="!isEdit">{{ $t('Add packaging') }}</h2>
        <h2 v-if="isEdit">{{ $t('Edit packaging') }}</h2>
      </template>
      <div>
        <InputSelect v-if="get_user.is_admin"
          class="m-b-20"
          :multiSelect=true
          :preselected="form.accessible_for_subaccounts"
          :label="$t('accessible_for_accounts')"
          @change="selectAccessibleSubaccount"
          :rules="{required: true}"
          :options="getAllowedSubaccounts" />
        <div class="row" style="margin-top: 25px">
          <div class="col-xs-6">
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Envelope')"
              :checked="form.type ? parseInt(form.type) === 1 : true"
              @input="form.type = 1"
              value="1" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Soft bags')"
              :checked="parseInt(form.type) === 2"
              @input="form.type = 2"
              value="2" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Box')"
              :checked="parseInt(form.type) === 3"
              @input="form.type = 3"
              value="3" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Tube')"
              :checked="parseInt(form.type) === 4"
              @input="form.type = 4"
              value="4" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Dunk')"
              :checked="parseInt(form.type) === 5"
              @input="form.type = 5"
              value="5" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Colli')"
              :checked="parseInt(form.type) === 6"
              @input="form.type = 6"
              value="6" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Bundle of bottles')"
              :checked="parseInt(form.type) === 7"
              @input="form.type = 7"
              value="7" />
          </div>
            <div class="col-xs-12 m-b-10">
              <RadioButton
                name="packageGroup"
                :text="$t('Euro pallet - 120cm x 80cm')"
                :checked="parseInt(form.type) === 16"
                @input="form.type = 16"
                value="16" />
            </div>
            <div class="col-xs-12 m-b-10">
              <RadioButton
                name="packageGroup"
                :text="$t('Pallet - 120cm x 80cm')"
                :checked="parseInt(form.type) === 17"
                @input="form.type = 17"
                value="17" />
            </div>
            <div class="col-xs-12 m-b-10">
              <RadioButton
                name="packageGroup"
                :text="$t('Pallet - unspecified')"
                :checked="parseInt(form.type) === 20"
                @input="form.type = 20"
                value="20" />
            </div>
        </div>
          <div class="col-xs-6">
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Parcel steel bottle')"
              :checked="parseInt(form.type) === 8"
              @input="form.type = 8"
              value="8" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Big bag')"
              :checked="parseInt(form.type) === 9"
              @input="form.type = 9"
              value="9" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Drum')"
              :checked="parseInt(form.type) === 10"
              @input="form.type = 10"
              value="10" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Jerry can')"
              :checked="parseInt(form.type) === 11"
              @input="form.type = 11"
              value="11" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Load steel bottle')"
              :checked="parseInt(form.type) === 12"
              @input="form.type = 12"
              value="12" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Crate')"
              :checked="parseInt(form.type) === 13"
              @input="form.type = 13"
              value="13" />
          </div>
          <div class="col-xs-12 m-b-10">
            <RadioButton
              name="packageGroup"
              :text="$t('Can')"
              :checked="parseInt(form.type) === 14"
              @input="form.type = 14"
              value="14" />
          </div>
            <div class="col-xs-12 m-b-10">
              <RadioButton
                name="packageGroup"
                :text="$t('IBC')"
                :checked="parseInt(form.type) === 15"
                @input="form.type = 15"
                value="15" />
            </div>
            <div class="col-xs-12 m-b-10">
              <RadioButton
                name="packageGroup"
                :text="$t('Half pallet - 80cm x 60cm')"
                :checked="parseInt(form.type) === 18"
                @input="form.type = 18"
                value="18" />
            </div>
            <div class="col-xs-12 m-b-10">
              <RadioButton
                name="packageGroup"
                :text="$t('Quarter pallet - 60cm x 40cm')"
                :checked="parseInt(form.type) === 19"
                @input="form.type = 19"
                value="19" />
            </div>
        </div>
        </div>
        <div class="separator medium"></div>
        <div class="row m-b-20">
          <div class="col-xs-8">
            <DimensionsSelect
              v-model="dimensions" />
          </div>
          <div class="col-xs-4">
            <WeightSelect
              label="Weight"
              v-model="form.weight "/>
          </div>
        </div>
        <div class="row">
          <InputText
            class="col-xs-12 m-b-20"
            :label="$t('Packaging name')"
            v-model="form.name"
            :rules="{required: true}" />
          <InputText
            class="col-xs-12"
            :label="$t('Ean number')"
            v-model="form.ean_number"/>
        </div>
        <div class="separator medium" v-if="isEdit"></div>
        <div class="row">
          <div class="col-xs-12" v-if="isEdit">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('delete') }}</p>
                <span>{{ $t('Packaging will be deleted') }}</span>
              </div>
              <div>
                <Toggle color="red" id="deletePackag" v-model="deletePackaging" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputSelect from '@/components/elements/inputs/select.vue';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import RadioButton from "@/components/elements/inputs/radio.vue";
import DimensionsSelect from '@/components/elements/inputs/dimensionsSelect.vue';
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';

import InfoTextBox from '@/components/global/infoTextBox';
import formValidator from '@/mixins/formValidator';

export default {
  name: 'Packages',
  mixins: [formValidator],
  components: { Btn, Popup, InputText, RadioButton, DimensionsSelect, WeightSelect, Toggle, InfoTextBox, InputSelect },
  data() {
    return {
      openPopup: false,
      deletePackaging: false,
      isEdit: false,
      packageId: '',
      dimensions: {
        width: {
          value: 0,
        },
        height: {
          value: 0,
        },
        length: {
          value: 0,
        },
        dimensionsType: '',
      },
      form: {
        accessible_for_subaccounts: [],
        name: '',
        type: 1,
        ean_number: '',
        weight: {
          value: '0',
          unit: 'kg',
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      'get_packages',
      'get_package_by_id',
      'get_subaccounts',
      'get_user'
    ]),
    isPopupSubmitDisabled() {
      if(this.get_user.is_admin && this.form.accessible_for_subaccounts.length == 0) return true;
      const formWithValidators = [
        {
          formFeild:'width',
          value: this.dimensions.width.value,
          validators:{required: true}
        },
        {
          formFeild:'height',
          value: this.dimensions.height.value,
          validators:{required: true}
        },
        {
          formFeild:'length',
          value: this.dimensions.length.value,
          validators:{required: true}
        },
        {
          formFeild:'name',
          value: this.form.name,
          validators:{required: true}
        },
      ]

      return this.validateInput(formWithValidators);
    },
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
  },
  created() {
    this.$store.dispatch('GET_PACKAGES');
  },
  methods: {
    selectAccessibleSubaccount(val) {
        this.form.accessible_for_subaccounts = val;
    },
    packagingItemName(type) {
      if(parseInt(type) === 1) return 'letter';
      if(parseInt(type) === 2) return 'softBag';
      if(parseInt(type) === 3) return 'savedItems';
      if(parseInt(type) === 4) return 'tube';
      if(parseInt(type) === 5) return 'tube';
      if(parseInt(type) === 6) return 'softBag';
      if(parseInt(type) === 7) return 'savedItems';
      if(parseInt(type) === 8) return 'savedItems';
      if(parseInt(type) === 9) return 'softBag';
      if(parseInt(type) === 10) return 'tube';
      if(parseInt(type) === 11) return 'tube';
      if(parseInt(type) === 12) return 'savedItems';
      if(parseInt(type) === 13) return 'savedItems';
      if(parseInt(type) === 14) return 'tube';
      if(parseInt(type) === 16) return 'pallet';
      if(parseInt(type) === 17) return 'pallet';
      if(parseInt(type) === 18) return 'pallet';
      if(parseInt(type) === 19) return 'pallet';
      if(parseInt(type) === 20) return 'pallet';

    },
    clearLocalFormData() {
      this.form = {
        accessible_for_subaccounts: [],
        name: '',
        type: 1,
        ean_number: '',
        weight: {
          value: '0',
          unit: 'kg',
        },
      };
      this.dimensions = {
        width: {
          value: 0,
        },
        height: {
          value: 0,
        },
        length: {
          value: 0,
        },
        dimensionsType: '',
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.packageId = '';
      this.clearLocalFormData();
    },
    submitForm() {
      const action = this.isEdit ? 'EDIT_PACKAGE' : 'SET_PACKAGE';
      this.form.accessible_for_subaccounts = this.form.accessible_for_subaccounts.filter((val) => this.get_user.accessible_subaccounts_array.indexOf(String(val)) > -1);

      this.$store.dispatch(`${action}`, {
        form: {
          accessible_for_subaccounts: this.form.accessible_for_subaccounts,
          name: this.form.name,
          type: this.form.type,
          ean_number: this.form.ean_number,
          weight: this.form.weight.value,
          width: this.dimensions.width.value,
          height: this.dimensions.height.value,
          length: this.dimensions.length.value,
          weight_measure: this.form.weight.unit,
          dimension_measure: this.dimensions.dimensionsType,
        },
        id: this.packageId || '',
      }).then(() => {
        this.$store.dispatch('GET_PACKAGES');
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    deletePackageAction() {
      this.$store.dispatch('DELETE_PACKAGE', this.packageId).then(() => {
        this.$store.dispatch('GET_PACKAGES');
        this.deletePackaging = false;
        this.isEdit = false;
        this.togglePopup();
      });
    },
    openNewPopup() {
      this.isEdit = false;
      this.togglePopup();
    },
    openEditPopup(id) {
      this.togglePopup();
      this.deletePackaging = false;
      this.isEdit = true;
      this.packageId = id;
      const packageObject = this.get_package_by_id(id);
      this.form = {
        accessible_for_subaccounts: packageObject.accessible_for_subaccounts,
        name: packageObject.name,
        type: packageObject.type,
        ean_number: packageObject.ean_number,
        weight: {
          value: packageObject.weight,
          unit: packageObject.weight_measure
        },
      };
      this.dimensions = {
        width: {
          value: packageObject.width,
        },
        height: {
          value: packageObject.height,
        },
        length: {
          value: packageObject.length,
        },
        dimensionsType: packageObject.dimension_measure
      };
    },
  },
};
</script>
